import { colorOptions } from '../../../components/CanvasEditor/components/Color/colorOptions';

import { rgbaToHex } from '../../../components/CanvasEditor/helpers/fabricHelpers';

const initialState = {
  pinned_tasks: {},
  pinned_plans: {},
  pinned_specifications: {},
  annotations: {},
};

const _transformData = (data, pinned_tasks) => {
  data.objects = data.objects.map((obj) => {
    if (obj.taskID && pinned_tasks[obj.taskID]) {
      return { ...obj, ...pinned_tasks[obj.taskID] };
    }
    return obj;
  });

  return data;
};

const _filterData = (data, filter_params) => {
  data = _.cloneDeep(data);

  const filterMap = {
    creator: 'userID',
    task_title: 'taskID',
    object_type: 'objectType',
    task_status: 'status',
    task_priority: 'priority',
    task_stage_discipline: 'stage_disciplines',
    task_assignee: 'assignee',
    stroke_color: 'stroke',
  };

  data.objects = _.filter(data.objects, (obj) => {
    return _.every(filterMap, (objKey, filterKey) => {
      const filterValue = _.get(filter_params, `filter.${filterKey}`);

      if (!filterValue) return true;
      const filterIds = _.split(filterValue, '|');

      // Only for object colors
      if (filterKey === 'stroke_color') {
        return _.some(filterIds, (colorName) => {
          const colorHex = _.find(colorOptions, {
            key: colorName,
          })?.hex;

          if (!colorHex) return false;

          const objHex = rgbaToHex(obj[objKey]);

          return objHex === colorHex;
        });
      }

      // If object has multiple values
      if (Array.isArray(obj[objKey])) {
        return _.some(obj[objKey], (val) => _.includes(filterIds, String(val)));
      }

      return _.includes(filterIds, String(obj[objKey]));
    });
  });

  return data;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.current_set_plans/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };

    case 'table.current_set_plans/LIST_PLAN_REVISION_TASKS_SUCCESS':
      return {
        ...state,
        pinned_tasks: action.response.data,
      };

    case 'table.current_set_plans/LIST_PINNED_PLAN_REVISION_SPECIFICATIONS_SUCCESS':
      return {
        ...state,
        pinned_specifications: action.response.data,
      };

    case 'table.current_set_plans/LIST_PLAN_REVISION_PLANS_SUCCESS':
      return {
        ...state,
        pinned_plans: action.response.data,
      };

    case 'table.current_set_plans/READ_PLAN_REVISION_ANNOTATION_SUCCESS':
      return {
        ...state,
        annotations: _filterData(
          _transformData(action.response.data, state.pinned_tasks),
          _.pickBy(state, (value, key) => {
            return _.startsWith(key, 'filter.');
          })
        ),

        initialAnnotations: action.response.data,
      };

    case 'table.current_set_plans/READ_PLAN_REVISION_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };

    case 'table.current_set_plans/FILTER_PLAN_REVISION_ANNOTATIONS':
      return {
        ...state,
        annotations: _filterData(
          state.initialAnnotations,
          _.pickBy(state, (value, key) => {
            return _.startsWith(key, 'filter.');
          }),
          state.pinned_tasks
        ),
        initialAnnotations: state.initialAnnotations,
      };

    case 'table.current_set_plans/LIST_CURRENT_SET_PLANS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };

    case 'table.current_set_plans/READ_CURRENT_SET_PLAN_SUCCESS':
      return {
        ...state,
        flyout: action.response.data,
      };

    default:
      return state;
  }
}
